import React from 'react';
import { BookModel } from '../../../interfaces/book.interface';
import { UserModel } from '../../../interfaces/user.interface';

interface BookCoverProps {
  storyPhoto?: string;
  bookData: BookModel | null;
  user: UserModel | null;
}

const BookCover: React.FC<BookCoverProps> = ({ storyPhoto, bookData, user }) => {
  return (
    <div
      className="h-[18rem] w-[18rem] md:w-[800px] md:h-[800px] rounded flex justify-center items-center relative mx-auto mt-8">
      <div
        className="absolute h-full w-full grayscale rounded"
        style={{
          backgroundImage: `url('${storyPhoto ? storyPhoto : '/pattern.png'}')`,
          backgroundSize: 'cover'
        }}
      ></div>
      <div
        className="h-[16rem] w-[13rem] pt-[1rem] md:w-[650px] md:h-[700px] rounded flex justify-center  md:pt-[2rem]"
        style={{
          backgroundImage: `url('${'/texture.png'}')`,
          backgroundSize: 'cover',
          zIndex: 1
        }}
      >
        <div
          className="h-[11rem] w-[11rem] md:w-[590px] md:h-[550px] rounded flex justify-center items-center relative"
          style={{
            backgroundImage: `url('${storyPhoto ? storyPhoto : '/pattern.png'}')`,
            backgroundSize: 'cover'
          }}
        >
          <div className="relative flex flex-col items-center top-[120px] md:top-[21rem] md:gap-2">
            <h1 className="text-base md:text-4xl text-center font-yuji-boku">{bookData?.title}</h1>
            <h1 className="font-poppins text-xs md:text-lg text-gray-600">
              by {user?.firstName} {user?.lastName}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookCover;
